export type Align = 'left' | 'center' | 'right' | 'default';
export type Label = string;
export type TableDetailsConfig = [Label, unknown];
